import React, { useState, useEffect } from "react";
import WaterWave from "react-water-wave";
import { isWaterWaveSupported, isMobileDevice } from "../helpers/browserHelper";

const WaterWaveWrapper = ({
  className,
  imageUrl,
  style,
  children,
  fallbackClassName = "",
  fallbackStyle = {},
}) => {
  const [shouldUseWaterWave, setShouldUseWaterWave] = useState(true);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
    // Check if WaterWave should be used
    const useWaterWave = isWaterWaveSupported();
    setShouldUseWaterWave(useWaterWave);
  }, []);

  // If not client-side yet, render nothing to avoid hydration mismatch
  if (!isClient) {
    return null;
  }

  // On mobile or unsupported browsers, show static banner
  if (!shouldUseWaterWave || isMobileDevice()) {
    return (
      <div
        className={`${className} ${fallbackClassName}`}
        style={{
          backgroundImage: `url(${imageUrl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          ...style,
          ...fallbackStyle,
        }}
      >
        {children}
      </div>
    );
  }

  // On supported desktop browsers, show WaterWave
  return (
    <WaterWave className={className} imageUrl={imageUrl} style={style}>
      {children}
    </WaterWave>
  );
};

export default WaterWaveWrapper;
